import React from 'react';
import { View, Platform, Text } from 'react-native';
import NoResult from 'tmpl/common/NoResult';
// import * as Sentry from '@sentry/react-native';
// import ypm from 'utils/spm';
import CommonBridge from 'common/CommonBridge';
// import StdNavBar from 'components/StdNavBar';
// import { getMakeTime } from 'common/ErrorUtils';
import Utils from 'utils/utils';
// import * as Sentry from '@sentry/react-native';
import Monitor, { ERROR_TYPES } from 'base/utils/monitor/index';
import { Uri } from './Uri';
import { AppContext } from './AppContext';

const getMakeTime = async () => {
  let makeTime = '';
  try {
    const data = await new Promise((resolve) => {
      CommonBridge.getRNInfo((result) => {
        resolve(result);
      });
    });
    makeTime = data.mstd.maketime;
  } catch (e) {
    makeTime = 20180504210903;
  }
  return makeTime;
};
const reportSentry = async (error) => {
  const deviceId = CommonBridge.DeviceId && CommonBridge.DeviceId.length > 0 ? CommonBridge.DeviceId : '';
  // Sentry.captureEvent({
  //   message: `miRNCrash: ${error.message}`,
  //   type: 'error',
  //   platform: Platform && Platform.OS,
  //   tags: {
  //     type: 'RNCrash',
  //     platform: (Platform && Platform.OS) || 'unknow',
  //     maketime: await getMakeTime(),
  //   },
  //   user: {
  //     deviceId: deviceId,
  //     username: deviceId,
  //     stack: (error.stack || '').substr(0, 200), // tag中无法支持字符串太长的tag
  //   },
  // });
};
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  static contextType = AppContext;

  componentDidCatch(error) {
    console.log('error-error:', error.message);
    try {
      // 上传错误日志
      const { uri } = this.props;
      if (!__DEV__) {
        this.context?.YPStatSend?.info(
          'RNCrash',
          `u=${encodeURIComponent(Utils.urlDel(Utils.urlDel(uri, 'last_scmv2'), 'scmv2_num'))}&type=${
            error.message
          }&stack=${encodeURIComponent((error.stack || '').substr(0, 300))}`,
        );
        reportSentry(error);
      }
      Monitor.recordErrorEvent({
        name: error.message,
        tags: {
          type: ERROR_TYPES.JAVASCRIPT,
        },
        info: {
          message: error.message,
          stack: error.stack,
        },
      }, { immediatelySend: true });
    } catch (e) {}
    this.setState({
      error,
    });
  }

  onPressBack = () => {
    const { instance } = this.props;
    Uri.back(instance);
  };

  render() {
    const { error } = this.state;
    if (error) {
      console.error('[Error Boundary:]_________________', error);
      // 如果页面崩溃，则显示下面的UI
      return (
        <View style={{ flex: 1, backgroundColor: '#ff0' }}>
          {/* <StdNavBar title="小米有品" onBackPress={this.onPressBack} /> */}
          <View style={{ flex: 1 }}>
            <NoResult
              imgSrc={{ uri: 'https://img.youpin.mi-img.com/shopcenter/144194d04c46a84e0cd81374528940ad.png' }}
              type="default"
              tipTxt={`数据加载异常，请稍后再试~(code: -10)`}
              btnTxt="返   回"
              btnClickFun={this.onPressBack}
            />
          </View>
        </View>
      );
    }
    return this.props.children;
  }
}

export { ErrorBoundary };
